const OBJECT_ID_REGEX = /^[a-fA-F0-9]{24}$/;

export const isValidObjectId = (objectId: string) => OBJECT_ID_REGEX.test(objectId);

export const extractDateFromObjectId = (objectId: string) => {
  if (!isValidObjectId(objectId)) {
    throw new Error(`Invalid object id; ${objectId}`);
  }

  return new Date(Number.parseInt(objectId.substring(0, 8), 16) * 1000);
};
